import { useState, useEffect, useCallback } from "react";
import { PRICE_SETTINGS_API, fetchWithAuth } from "../utils/api";

/**
 * Hook to fetch and manage available divisions from competition pricing settings
 */
export function useDivisions() {
  const [divisions, setDivisions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchDivisions = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);
      
      // Fetch pricing settings to get competition pricing rules
      const pricingData = await fetchWithAuth(PRICE_SETTINGS_API);
      
      // Extract divisions from competition pricing categories
      const competitionPricing = pricingData?.competitionPricing || [];
      const divisionsList = competitionPricing
        .map(rule => rule.category)
        .filter(category => category && category.trim() !== "")
        .filter((category, index, arr) => arr.indexOf(category) === index) // Remove duplicates
        .sort(); // Sort alphabetically
      
      console.log('Fetched divisions from pricing settings:', divisionsList);
      setDivisions(divisionsList);
    } catch (err) {
      console.error("Error fetching divisions:", err);
      setError(err.message || "Failed to load divisions");
      setDivisions([]);
    } finally {
      setLoading(false);
    }
  }, []);

  // Load divisions on mount
  useEffect(() => {
    fetchDivisions();
  }, [fetchDivisions]);

  return {
    divisions,
    loading,
    error,
    refetchDivisions: fetchDivisions
  };
}
